module.exports = __webpack_public_path__ + "img/logo_flickr.94cb0df5.svg";